import { render } from "./Step1.vue?vue&type=template&id=0a960aba&ts=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__